import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './click-outside.directive';
import { NumberDirective } from './number.directive';
import { CalsoftTrimDirective } from './calsoft-trim.directive';
import { ScrollLockOnSelectDirective } from './scroll-lock-on-select.directive';
import { TrackClickDirective } from '../click-track/track-click.directive';



import { GuideDirective } from './guide.directive';
import { ResizableDirective } from './resizable.directive';

@NgModule({
  declarations: [ClickOutsideDirective, NumberDirective, CalsoftTrimDirective, ScrollLockOnSelectDirective, GuideDirective, ResizableDirective, TrackClickDirective],
  imports: [
    CommonModule
  ],
  exports: [
    ClickOutsideDirective, NumberDirective, CalsoftTrimDirective, ScrollLockOnSelectDirective, GuideDirective, ResizableDirective, TrackClickDirective
  ]
})
export class DirectiveModule { }
